<template>
  <div :class="prefixCls + '-operation'">
    <Button type="primary" :disabled="!leftActive" @click.native="moveToRight">
        <span>{{ operations[1] }}</span>
    </Button>
    <Button type="primary" :disabled="!rightActive" @click.native="moveToLeft">
        <span>{{ operations[0] }}</span>
    </Button>
  </div>
</template>
<script>
export default {
  name: 'Operation',
  props: {
    prefixCls: String,
    operations: Array,
    leftActive: Boolean,
    rightActive: Boolean
  },
  methods: {
    moveToLeft () {
      this.$parent.moveTo('left')
    },
    moveToRight () {
      this.$parent.moveTo('right')
    }
  }
}
</script>
